import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import Header from "@/components/sections/Header";
import Footer from "@/components/sections/Footer";
import { fadeUp } from "@/lib/motion";

const sections = [
  {
    title: "1. Υπεύθυνη Επεξεργασίας",
    body: (
      <>
        Υπεύθυνη επεξεργασίας των προσωπικών σας δεδομένων είναι η Άννα
        Παπαχρονόπουλου, Ψυχολόγος, με έδρα: Ρήγα Φεραίου 119, Πάτρα, Ελλάδα.
        Email: anniepapach@gmail.com · Τηλέφωνο: 697 8042 360.
      </>
    ),
  },
  {
    title: "2. Ποια δεδομένα συλλέγουμε",
    body: (
      <>
        <strong>Φόρμα επικοινωνίας:</strong> ονοματεπώνυμο, email, τηλέφωνο
        (προαιρετικά) και το μήνυμά σας.
        <br />
        <strong>Ψηφιακός βοηθός (AI chat):</strong> τα μηνύματα που
        πληκτρολογείτε στη συνομιλία και ένα ανώνυμο αναγνωριστικό συνεδρίας
        (session id) που αποθηκεύεται στη συσκευή σας.
        <br />
        <strong>Απευθείας μήνυμα μέσω του βοηθού:</strong> ονοματεπώνυμο, email,
        τηλέφωνο (προαιρετικά), το σημείωμά σας και το ιστορικό της συγκεκριμένης
        συνομιλίας.
        <br />
        <strong>Cookies / ανάλυση επισκεψιμότητας:</strong> μόνο εφόσον
        αποδεχθείτε τα προαιρετικά cookies, συλλέγονται ανώνυμα στατιστικά
        χρήσης της σελίδας (PostHog).
      </>
    ),
  },
  {
    title: "3. Σκοπός & νομική βάση επεξεργασίας",
    body: (
      <>
        Τα δεδομένα σας χρησιμοποιούνται αποκλειστικά για: (α) την απάντηση στα
        μηνύματα και αιτήματά σας και τον προγραμματισμό συνεδριών (νομική βάση:
        ενέργειες πριν από τη σύναψη σύμβασης, άρθρο 6 παρ. 1β ΓΚΠΔ), (β) τη
        λειτουργία του ψηφιακού βοηθού (έννομο συμφέρον, άρθρο 6 παρ. 1στ ΓΚΠΔ)
        και (γ) τη βελτίωση της ιστοσελίδας μέσω ανώνυμων στατιστικών, μόνο με
        τη συγκατάθεσή σας (άρθρο 6 παρ. 1α ΓΚΠΔ). Δεν πραγματοποιείται λήψη
        αυτοματοποιημένων αποφάσεων ούτε κατάρτιση προφίλ.
      </>
    ),
  },
  {
    title: "4. Ο ψηφιακός βοηθός (AI) — σημαντική ενημέρωση",
    body: (
      <>
        Ο ψηφιακός βοηθός της ιστοσελίδας βασίζεται σε τεχνολογία τεχνητής
        νοημοσύνης (Google Gemini). <strong>Δεν παρέχει ψυχολογική διάγνωση,
        θεραπεία ή ιατρικές συμβουλές</strong> — προσφέρει μόνο γενικές
        πληροφορίες και ψυχοεκπαιδευτικό περιεχόμενο. Σας συνιστούμε να μη
        μοιράζεστε στη συνομιλία περισσότερα ευαίσθητα προσωπικά δεδομένα από
        όσα είναι απαραίτητα. Τα μηνύματα της συνομιλίας διαβιβάζονται στον
        πάροχο του μοντέλου αποκλειστικά για την παραγωγή της απάντησης. Σε
        περίπτωση έκτακτης ανάγκης καλέστε 166 (ΕΚΑΒ), 1018 (Γραμμή Παρέμβασης
        για την Αυτοκτονία) ή 112.
      </>
    ),
  },
  {
    title: "5. Αποδέκτες & εκτελούντες την επεξεργασία",
    body: (
      <>
        Τα δεδομένα σας δεν πωλούνται ούτε διαβιβάζονται σε τρίτους για
        διαφημιστικούς σκοπούς. Χρησιμοποιούνται μόνο οι απολύτως απαραίτητοι
        τεχνικοί πάροχοι: υπηρεσία αποστολής email (Resend) για την παράδοση των
        μηνυμάτων σας, πάροχος τεχνητής νοημοσύνης (Google Gemini) για τις
        απαντήσεις του βοηθού, υπηρεσία ανώνυμων στατιστικών (PostHog — μόνο με
        συγκατάθεση) και ο πάροχος φιλοξενίας της ιστοσελίδας. Όλοι δεσμεύονται
        από αντίστοιχες συμβάσεις επεξεργασίας δεδομένων.
      </>
    ),
  },
  {
    title: "6. Χρόνος διατήρησης",
    body: (
      <>
        Τα μηνύματα επικοινωνίας και οι συνομιλίες με τον βοηθό διατηρούνται για
        όσο διάστημα απαιτείται για την εξυπηρέτηση του αιτήματός σας και έως 24
        μήνες κατ' ανώτατο όριο, εκτός αν προκύψει θεραπευτική συνεργασία, οπότε
        ισχύουν οι προβλέψεις της επαγγελματικής νομοθεσίας ψυχολόγων. Μπορείτε
        να ζητήσετε διαγραφή νωρίτερα οποιαδήποτε στιγμή.
      </>
    ),
  },
  {
    title: "7. Cookies",
    body: (
      <>
        Η ιστοσελίδα χρησιμοποιεί: (α) <strong>απαραίτητα cookies</strong> για
        τη βασική λειτουργία της (π.χ. αποθήκευση της επιλογής σας για τα
        cookies και του αναγνωριστικού συνομιλίας του βοηθού) και (β){" "}
        <strong>προαιρετικά cookies στατιστικών</strong> (PostHog), τα οποία
        ενεργοποιούνται ΜΟΝΟ αν πατήσετε «Αποδοχή όλων» στο σχετικό μήνυμα.
        Μπορείτε να αλλάξετε την επιλογή σας διαγράφοντας τα δεδομένα της
        ιστοσελίδας από τον browser σας.
      </>
    ),
  },
  {
    title: "8. Τα δικαιώματά σας",
    body: (
      <>
        Σύμφωνα με τον Γενικό Κανονισμό Προστασίας Δεδομένων (ΕΕ 2016/679),
        έχετε δικαίωμα πρόσβασης, διόρθωσης, διαγραφής («δικαίωμα στη λήθη»),
        περιορισμού της επεξεργασίας, φορητότητας και εναντίωσης, καθώς και
        ανάκλησης της συγκατάθεσής σας ανά πάσα στιγμή. Για την άσκηση των
        δικαιωμάτων σας επικοινωνήστε στο anniepapach@gmail.com. Έχετε επίσης
        δικαίωμα καταγγελίας στην Αρχή Προστασίας Δεδομένων Προσωπικού
        Χαρακτήρα (www.dpa.gr).
      </>
    ),
  },
  {
    title: "9. Ασφάλεια",
    body: (
      <>
        Λαμβάνονται κατάλληλα τεχνικά και οργανωτικά μέτρα για την προστασία των
        δεδομένων σας (κρυπτογραφημένη σύνδεση HTTPS, περιορισμένη πρόσβαση,
        ασφαλής αποθήκευση). Καμία διαδικτυακή μετάδοση δεν είναι απολύτως
        ασφαλής — για ιδιαίτερα ευαίσθητα θέματα προτιμήστε την τηλεφωνική
        επικοινωνία.
      </>
    ),
  },
  {
    title: "10. Αλλαγές στην παρούσα πολιτική",
    body: (
      <>
        Η παρούσα πολιτική ενδέχεται να επικαιροποιείται. Η εκάστοτε ισχύουσα
        έκδοση δημοσιεύεται σε αυτή τη σελίδα. Τελευταία ενημέρωση: Ιούνιος
        2026.
      </>
    ),
  },
];

export default function Privacy() {
  return (
    <>
      <Helmet>
        <html lang="el-GR" />
        <title>{"Πολιτική Απορρήτου · Άννα Παπαχρονόπουλου, Ψυχοθεραπεία Πάτρα"}</title>
        <meta
          name="description"
          content="Πολιτική απορρήτου και προστασίας προσωπικών δεδομένων (GDPR) της ιστοσελίδας psyloveyourself.com — Άννα Παπαχρονόπουλου, Ψυχοθεραπεία στην Πάτρα."
        />
        <link rel="canonical" href="https://psyloveyourself.com/politiki-aporritou" />
      </Helmet>

      <Header />

      <main className="bg-background pt-32 pb-24 min-h-screen" data-testid="privacy-page">
        <div className="max-w-[820px] mx-auto px-6 sm:px-12">
          <motion.div {...fadeUp}>
            <Link
              to="/"
              data-testid="privacy-back-link"
              className="inline-flex items-center gap-2 text-sm font-body text-muted-foreground hover:text-foreground transition-colors mb-10"
            >
              <ArrowLeft size={14} strokeWidth={1.5} />
              Αρχική
            </Link>

            <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-primary/10 text-primary mb-7">
              <ShieldCheck size={22} strokeWidth={1.5} />
            </div>

            <p className="text-[11px] tracking-[0.25em] uppercase font-body font-medium text-primary mb-4">
              GDPR · Προστασία δεδομένων
            </p>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight text-foreground">
              Πολιτική <span className="italic font-light">Απορρήτου</span>
            </h1>
            <p className="mt-6 font-body font-light text-muted-foreground leading-relaxed max-w-[620px]">
              Η προστασία των προσωπικών σας δεδομένων είναι θεμελιώδης — ειδικά
              όταν αφορά θέματα ψυχικής υγείας. Εδώ εξηγείται με απλά λόγια τι
              συλλέγεται, γιατί, και ποια είναι τα δικαιώματά σας.
            </p>
          </motion.div>

          <div className="mt-14 space-y-10">
            {sections.map((s, i) => (
              <motion.section
                key={s.title}
                {...fadeUp}
                transition={{ ...fadeUp.transition, delay: Math.min(i * 0.05, 0.3) }}
              >
                <h2 className="font-heading text-lg md:text-lg text-foreground mb-3">
                  {s.title}
                </h2>
                <p className="font-body font-light text-sm text-foreground/80 leading-relaxed">
                  {s.body}
                </p>
              </motion.section>
            ))}
          </div>

          <motion.div
            {...fadeUp}
            className="mt-16 p-8 bg-card border border-border/60 rounded-3xl"
          >
            <p className="font-body text-sm text-foreground/80 leading-relaxed">
              Έχετε ερωτήσεις για τα δεδομένα σας; Επικοινωνήστε στο{" "}
              <a
                href="mailto:anniepapach@gmail.com"
                className="underline underline-offset-4 text-foreground"
              >
                anniepapach@gmail.com
              </a>{" "}
              ή στο 697 8042 360.
            </p>
          </motion.div>
        </div>
      </main>

      <Footer />
    </>
  );
}
